import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { prepareHeaders, getApiBaseUrl, getApiConfigKey } from 'utility/Api'
import apiConfig from './api-config'

const baseUrl = getApiBaseUrl()
const configKey = getApiConfigKey()
const apiPath = apiConfig[configKey].paths.apiPathFeature ?? ''

// Define a service using a base URL and expected endpoints
export const FeatureApi = createApi({
  reducerPath: 'featureApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/${apiPath}`,
    prepareHeaders: async headers => await prepareHeaders(headers)
  }),
  endpoints: builder => ({
    getFeatures: builder.query<string[], void>({
      query: () => 'features/sponsored-accounts'
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetFeaturesQuery } = FeatureApi
